import axios from 'axios';

const PortalClassAttendance = {
    namespaced: true,
    actions: {
        CreateClassAttendance({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalClassAttendance/CreateClassAttendance`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        CreateClassAttendanceMidTerm({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalClassAttendance/CreateClassAttendanceMidTerm`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        GetStudentForClassAttendance({ rootState }, { SectionId, RegisteredTermId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalClassAttendance/GetStudentForClassAttendance?SectionId=${SectionId}&RegisteredTermId=${RegisteredTermId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetStudentForClassAttendanceMidTerm({ rootState }, { SectionId, RegisteredTermId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalClassAttendance/GetStudentForClassAttendanceMidTerm?SectionId=${SectionId}&RegisteredTermId=${RegisteredTermId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetClassAttendances({ rootState }, { SectionId, RegisteredTermId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalClassAttendance/GetClassAttendances?SectionId=${SectionId}&RegisteredTermId=${RegisteredTermId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetClassAttendancesByStudentId({ rootState }, { StudentId, RegisteredTermId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalClassAttendance/GetClassAttendancesByStudentId?StudentId=${StudentId}&RegisteredTermId=${RegisteredTermId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

    }
}

export default PortalClassAttendance